// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__1pJS4","ellipsis":"styles_ellipsis__E_qbu","text2AndMoreLines":"styles_text2AndMoreLines__CQBmf","tooltipTrigger":"styles_tooltipTrigger___fl6_"};